import React from 'react'
import {
  useGetSingleGoal,
  useGetSingleTeamGoal,
} from '../../../redux/human-resources/hook/performance'
import { useParams } from 'react-router-dom'
import EditGoal from './EditGoal'
import LoadingBar from '../../../components/loader-bar'
import DashboardLayout from '../../../components/layouts/dashboard'

const RenderGoal = () => {
  const { id, type } = useParams()
  const isTeam = type === 'team'

  const {
    data: singleGoal,
    isLoading,
    refetch,
  } = isTeam ? useGetSingleTeamGoal(id) : useGetSingleGoal(id)

  return (
    <DashboardLayout title='Performance Management'>
      {isLoading ? (
        <div className=' w-full flex flex-col items-center justify-center gap-5 h-[70vh]'>
          <LoadingBar loading={isLoading} />
          <div
            className={
              'text-center animate-pulse p1-bold flex items-center justify-center h-[100px] text-secondary-2'
            }
          >
            Loading...
          </div>
        </div>
      ) : (
        <>
          <EditGoal
            singleGoal={singleGoal}
            isLoading={isLoading}
            refetch={refetch}
          />
        </>
      )}
    </DashboardLayout>
  )
}

export default RenderGoal
